import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lootbox-info" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "coins" }
const _hoisted_4 = {
  key: 1,
  disabled: "",
  class: "btn btn-lg btn-secondary w-100"
}
const _hoisted_5 = { class: "lootbox-content" }
const _hoisted_6 = { class: "items" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "coins" }

import PopupWrapper from "@/components/PopupWrapper.vue";
import {reactive} from "@vue/reactivity";
import {computed, nextTick, onBeforeUnmount, ref} from "vue";
import StoreItemDTO from "@/models/StoreItemDTO";
import StoreLootBoxDTO from "@/models/StoreLootBoxDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import MoneyDTO from "@/models/MoneyDTO";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {AppEvents} from "@/models/enum/AppEvents";
import {api} from "@/service/APIClient";
import {PurchaseStatus} from "@/models/enum/PurchaseStatus";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import SvgIcon from "@/components/SvgIcon.vue";

const IDLE_SPEED = 120;
const COPIES = 3

type Roll = {
  startOffset: number
  targetOffset: number
  startTs: number
  duration: number
  targetIndex: number
} | null

export default /*@__PURE__*/_defineComponent({
  __name: 'LootboxPopup',
  setup(__props, { expose: __expose }) {

const notification = useNotification()
const store = useStore()
const router = useRouter()

const state = reactive({
  item: null as StoreItemDTO|null,
  isOpening: false as boolean,
  winIndex: null as number|null
})

const lootBox = computed(() => {
  return state.item?.content as StoreLootBoxDTO|null
})

const loopedItems = computed(() => {
  if (!state.item) {
    return []
  }

  return Array.from({length: COPIES}, () => {
    return (state.item?.content as StoreLootBoxDTO).items.map((item, index) => {
      return item
    })
  }
  ).flat()
})

const trackEl = ref<HTMLElement | null>(null)
const wrapEl = ref<HTMLElement | null>(null)
let offset = 0
let setWidth = 0
let rafId: number | null = null
let lastTs = 0
let isPaused = false
let cardStep = 0
let wrapWidth = 0

function measure() {
  const t = trackEl.value, w = wrapEl.value
  if (!t || !w) return
  setWidth  = t.scrollWidth / COPIES
  cardStep  = setWidth / (state.item?.content as StoreLootBoxDTO).items.length
  wrapWidth = w.clientWidth
}

let roll: Roll = null

function easeOutQuart(t: number) {
  return 1 - Math.pow(1 - t, 4)
}

function startRoll(chosenIdx: number, duration = 6000, minSpins = 5) {
  console.log("roll start", chosenIdx)
  measure()

  const minimalOffset = chosenIdx * cardStep + cardStep / 2 - wrapWidth / 2
  const tail = (((minimalOffset - offset) % setWidth) + setWidth) % setWidth
  const target = offset + minSpins * setWidth + tail

  roll = {
    startOffset: offset,
    targetOffset: target,
    startTs: performance.now(),
    duration,
    targetIndex: chosenIdx,
  }
}

function frame(ts: number) {
  if (!lastTs) lastTs = ts
  const dt = (ts - lastTs) / 1000
  lastTs = ts

  const el = trackEl.value
  if (el && setWidth > 0) {
    if (roll) {
      const t = Math.min(1, (ts - roll.startTs) / roll.duration)
      const eased = easeOutQuart(t)
      offset = roll.startOffset + (roll.targetOffset - roll.startOffset) * eased

      if (t >= 1) {
        offset = roll.targetOffset
        const idx = roll.targetIndex
        roll = null
        isPaused = true
        state.isOpening = false
        state.winIndex = idx
        const text = $t('amount_added_to_balance', {amount: numberFormatter.formatNumber((state.item?.content as StoreLootBoxDTO).items[state.winIndex].sum)});
        notification.notify({type: 'success', title: `<div class="d-flex align-items-center gap-1"><img src="/img/coins/gold_coin.svg"> ${text}</div>`, duration: 1500})
      }
    } else if (!isPaused) {
      offset += IDLE_SPEED * dt
    }
    const display = ((offset % setWidth) + setWidth) % setWidth
    el.style.transform = `translate3d(${-display}px, 0, 0)`
  }

  rafId = requestAnimationFrame(frame)
}


const show = async (item: StoreItemDTO) => {
  state.item = item
  state.isOpening = false
  state.winIndex = null
  isPaused = false
  popup.value?.show();
  await nextTick()
  measure()
  rafId = requestAnimationFrame(frame)
}

const hide = () => {
  popup.value?.hide()
}

const onHide = () => {
  if (rafId) cancelAnimationFrame(rafId)
}

const buy = () => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }

  state.winIndex = null
  isPaused = false
  state.isOpening = true
  store.dispatch('emit', {event: AppEvents.BUY_ITEM, data: state.item})
}

const events = store.subscribeAction({
  before: async (action) => {
    if (action.type !== 'emit') {
      return;
    }
    switch (action.payload?.event) {
      case AppEvents.PURCHASE_CANCELED:
        state.isOpening = false;
        break;
      case AppEvents.PURCHASE_COMPLETED:
        const purchase = await api.call.purchases.get(action.payload?.data.purchaseId)
        console.log(purchase)
        if (purchase.status === PurchaseStatus.COMPLETED) {
          startRoll(purchase.metadata.index, 5000, 5)
        }
        break;
    }
  },
})


onBeforeUnmount(events)

__expose({ show, hide })
const popup = ref<InstanceType<typeof PopupWrapper> | null>(null)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrapper, {
    onOnHide: onHide,
    title: _unref(state).item?.name,
    ref: (el) => popup.value = el,
    class: "popup-float",
    "hide-close-btn": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "lootbox-wrap",
          ref_key: "wrapEl",
          ref: wrapEl
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "lootbox-marker" }, null, -1)),
          _createElementVNode("div", {
            ref_key: "trackEl",
            ref: trackEl,
            class: "lootbox-track"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loopedItems.value, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass(["lootbox-card", [_unref(state).winIndex !== null && item.index !== _unref(state).winIndex ? 'inactive' : '', _unref(state).winIndex !== null && item.index === _unref(state).winIndex ? 'win' : '']]),
                style: _normalizeStyle({background: `linear-gradient(180deg, ${item.color} 0%, #18181B 100%)`})
              }, [
                _createElementVNode("img", {
                  class: "icon",
                  src: item.iconUrl
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(item.sum)), 1)
                ])
              ], 6))
            }), 128))
          ], 512)
        ], 512),
        (!_unref(state).isOpening)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _withModifiers(buy, ["prevent"]),
              class: "btn btn-lg btn-primary w-100"
            }, _toDisplayString(_unref($t)('open_for', {price: _unref(numberFormatter).formatMoney(_unref(state).item.price)})), 1))
          : (_openBlock(), _createElementBlock("button", _hoisted_4, [
              _createVNode(SvgIcon, { icon: "loader-icon" }),
              _createTextVNode(" " + _toDisplayString(_unref($t)('opening')), 1)
            ])),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, _toDisplayString(_unref($t)('whats_inside')), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lootBox.value?.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(numberFormatter).formatNumber(item.sum)), 1)
                ]),
                _createElementVNode("span", {
                  class: "type",
                  style: _normalizeStyle({color:item.color})
                }, _toDisplayString(item.name) + " · " + _toDisplayString(_unref(numberFormatter).formatNumber(item.weight, 1)) + "%", 5)
              ]))
            }), 256))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})